let currentUid = 0
export default (_, inject) => {
    /** Provides unique id */
    function getUID() {
        currentUid++
        return currentUid
    }
    inject("getUID", getUID)
}
